export default __webpack_public_path__ + "static/media/squareTwitgraph.2408f474.png";